module.exports = __webpack_public_path__ + "assets/img/customers6.5d1f47d5.png";